import React, { useEffect, useRef, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

//redux
import { userActions } from '../User/UserActions';
import { useDispatch, useSelector } from 'react-redux';

//components and helpers
import logo from '../../assets/img/hde_logo.svg';

//swipable-views
import SwipeableViews from 'react-swipeable-views';

//material-ui
import { useTheme } from '@mui/material';
import Button from '@mui/material/Button';
import MobileStepper from '@mui/material/MobileStepper';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

interface Props {
    steps?: any;
    classes?: any;
    setFirstLogin?: any;
    activeStep?: any;
    setActiveStep?: any;
    handleStepChange?: any;
    userDetails?: any;
    dependentActions?: any;
    handleBack?: any;
    handleNext?: any;
    closeDependentDialog?: any;
    dependents?: any;
    recordsActions?: any;
    handleAcceptedTc?: any;
    setDependentData?: any;
}

const Onboarding: React.FC<Props> = (props) => {
    let { steps, activeStep, handleStepChange, handleBack, handleNext } = props;
    const { logout } = useAuth0();
    const theme = useTheme();
    const vidRef = useRef();
    const dispatch = useDispatch();
    const currentUser = useSelector((state: any) => state.user.currentUser);
    const currentUserConfig = useSelector(
        (state: any) => state.user.currentUserConfig
    );
    const currentUserLoading = useSelector(
        (state: any) => state.user.currentUserLoading
    );
    // State, useState setup
    const [isEditing] = useState(true);
    const [policyCheck, setPolicyCheck] = useState(false);
    const [error, setError] = useState(false);
    const [, setPhoneNumber] = useState('');
    const [accountInfo, setAccountInfo] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        company: '',
        jobTitle: '',
        userId: '',
        id: '',
        role: '',
    });
    const [, setAccountConfig] = useState({
        isFirstTime: true, // no longer inverted
    });

    useEffect(() => {
        if (!currentUserLoading && !accountInfo.userId) {
            setAccountInfo(currentUser);
        }
    }, [currentUser, currentUserLoading, accountInfo.userId]);

    useEffect(() => {
        setAccountConfig(currentUserConfig);
    }, [currentUserConfig]);

    useEffect(() => {
        if (activeStep !== 1) {
            const videos = document.querySelectorAll('iframe, video');
            Array.prototype.forEach.call(videos, function (video) {
                if (video.tagName.toLowerCase() === 'video') {
                    video.pause();
                } else {
                    const src = video.src;
                    video.src = src;
                }
            });
        }
    }, [activeStep]);

    const handlePolicyAgree = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPolicyCheck(event.target.checked);
    };

    // Next up is the handle change functions

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (name === 'phoneNumber') {
            let formattedInput = value.replace(/\D/g, ''); // remove non-numbers
            if (formattedInput.length > 3) {
                const part1 = formattedInput.substring(0, 3);
                const part2 = formattedInput.substring(3);
                formattedInput = `${part1}-${part2}`;
            }
            if (formattedInput.length > 7) {
                const part1 = formattedInput.substring(0, 7);
                const part2 = formattedInput.substring(7);
                formattedInput = `${part1}-${part2}`;
            }
            if (formattedInput.length <= 11 && formattedInput.length >= 1) {
                setError(true);
            }
            if (formattedInput.length >= 12 || formattedInput.length === 0) {
                setError(false);
            }
            setAccountInfo((prevInfo) => ({
                ...prevInfo,
                [name]: formattedInput,
            }));
            setPhoneNumber(formattedInput);
        } else {
            setAccountInfo((prevInfo) => ({
                ...prevInfo,
                [name]: value,
            }));
        }
    };

    // Last but not least is the handle button click functions

    const handleCreateClick = () => {
        dispatch(userActions.updateUser(accountInfo));
        dispatch(
            userActions.updateUserConfig({
                isFirstTime: false, // no longer inverted
            })
        );
    };

    const handleLogout = () => {
        // @ts-ignore
        logout({ returnTo: window.location.origin });
    };

    return (
        <Grid
            container
            justifyContent={'center'}
            sx={{
                p: 2,
                height: '100%',
            }}
            spacing={6}
        >
            <Grid item xs={12}>
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <Button
                            variant={'contained'}
                            color={'secondary'}
                            onClick={handleLogout}
                            size={'small'}
                        >
                            Logout
                        </Button>
                    </Grid>
                    <Grid item>
                        <img src={logo} alt="" height={60} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={10}>
                <Paper elevation={4} style={{ borderRadius: 20 }}>
                    <Chip
                        label="Getting Started"
                        sx={{
                            fontSize: 18,
                            backgroundColor: '#663299',
                            color: '#fff',
                            p: 1,
                            m: 3,
                        }}
                    />
                    <SwipeableViews
                        index={activeStep}
                        onChangeIndex={handleStepChange}
                        data-testid={'swipeable-view'}
                    >
                        {steps(isEditing, error).map((step, i) => {
                            return (
                                <Grid container key={`step-${i}`}>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{ m: 2 }}
                                        style={{
                                            paddingLeft: 14,
                                            paddingRight: 14,
                                        }}
                                    >
                                        <Typography
                                            color={'primary'}
                                            variant={'h5'}
                                            sx={{ fontWeight: 'bold' }}
                                        >
                                            {step.title}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{ m: 2 }}
                                        style={{
                                            paddingLeft: 14,
                                            paddingRight: 14,
                                        }}
                                    >
                                        <Typography
                                            color={'primary'}
                                            variant={'body1'}
                                        >
                                            {step.subtext}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            mt: activeStep !== 3 ? 3 : 1,
                                            mb: 3,
                                            p: 2,
                                            background:
                                                activeStep !== 3
                                                    ? 'linear-gradient(95deg, #663299 0.66%, #325599 100%)'
                                                    : 'transparent',
                                        }}
                                    >
                                        {step.contentType === 'feature' && (
                                            <Grid
                                                container
                                                justifyContent={'center'}
                                            >
                                                {step.features.map(
                                                    (feature, i) => {
                                                        return (
                                                            <Grid
                                                                item
                                                                xs={4}
                                                                sx={{ p: 2 }}
                                                                key={`feature-${feature.name}-${i}`}
                                                            >
                                                                <Grid
                                                                    container
                                                                    alignItems={
                                                                        'center'
                                                                    }
                                                                    direction={
                                                                        'column'
                                                                    }
                                                                    spacing={2}
                                                                >
                                                                    <Grid item>
                                                                        <img
                                                                            src={
                                                                                feature.icon
                                                                            }
                                                                            alt=""
                                                                        />
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <Typography
                                                                            color={
                                                                                '#fff'
                                                                            }
                                                                            variant={
                                                                                'h6'
                                                                            }
                                                                            sx={{
                                                                                textAlign:
                                                                                    'center',
                                                                            }}
                                                                        >
                                                                            {
                                                                                feature.title
                                                                            }
                                                                        </Typography>{' '}
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <Typography
                                                                            color={
                                                                                '#fff'
                                                                            }
                                                                            variant={
                                                                                'body1'
                                                                            }
                                                                            sx={{
                                                                                textAlign:
                                                                                    'center',
                                                                            }}
                                                                        >
                                                                            {
                                                                                feature.subtext
                                                                            }
                                                                        </Typography>{' '}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        );
                                                    }
                                                )}
                                            </Grid>
                                        )}
                                        {step.contentType === 'policy' && (
                                            <Grid
                                                container
                                                justifyContent={'center'}
                                                spacing={2}
                                                style={{
                                                    paddingLeft: 14,
                                                    paddingRight: 14,
                                                }}
                                            >
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant={'body1'}
                                                        sx={{
                                                            fontWeight: 'bold',
                                                        }}
                                                    >
                                                        {step.policyTitle}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant={'body2'}
                                                    >
                                                        {step.policyIntro}
                                                    </Typography>
                                                </Grid>
                                                {step.policies.map(
                                                    (policy, i) => {
                                                        return (
                                                            <Grid
                                                                item
                                                                xs={12}
                                                                key={`policy-${i}`}
                                                            >
                                                                <Grid
                                                                    container
                                                                    justifyContent={
                                                                        'flex-start'
                                                                    }
                                                                >
                                                                    <Grid
                                                                        item
                                                                        xs={11}
                                                                    >
                                                                        <Typography
                                                                            variant={
                                                                                'body1'
                                                                            }
                                                                            sx={{
                                                                                fontWeight:
                                                                                    'bold',
                                                                            }}
                                                                        >
                                                                            {
                                                                                policy.title
                                                                            }
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid
                                                                        item
                                                                        xs={11}
                                                                    >
                                                                        <Typography
                                                                            variant={
                                                                                'body2'
                                                                            }
                                                                        >
                                                                            {
                                                                                policy.content
                                                                            }
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        );
                                                    }
                                                )}
                                                <Grid item xs={12}>
                                                    <Typography
                                                        variant={'body2'}
                                                    >
                                                        {step.conclusion}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <FormControlLabel
                                                        required
                                                        color={'secondary'}
                                                        control={
                                                            <Checkbox
                                                                data-testid={
                                                                    'agree-checkbox'
                                                                }
                                                                color={
                                                                    'primary'
                                                                }
                                                                onChange={
                                                                    handlePolicyAgree
                                                                }
                                                            />
                                                        }
                                                        label="I Agree"
                                                    />
                                                </Grid>
                                            </Grid>
                                        )}
                                        {step.contentType === 'video' && (
                                            <Grid
                                                item
                                                xs={12}
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center', // Centers the video horizontally
                                                    alignItems: 'center', // Centers the video vertically
                                                    position: 'relative',
                                                    paddingBottom: '30%',
                                                    overflow: 'hidden',
                                                }}
                                            >
                                                <iframe
                                                    id={'videoId'}
                                                    ref={vidRef}
                                                    src={step.video}
                                                    title="YouTube video player"
                                                    frameBorder="0"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                    allowFullScreen
                                                    style={{
                                                        overflow: 'hidden',
                                                        border: 0,
                                                        position: 'absolute',
                                                        alignSelf: 'center',
                                                        top: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                    }}
                                                ></iframe>
                                            </Grid>
                                        )}
                                        {step.contentType === 'form' && (
                                            <Grid item xs={12}>
                                                <Grid
                                                    container
                                                    spacing={6}
                                                    sx={{ p: 2 }}
                                                >
                                                    {step.formFields.map(
                                                        (field, i) => {
                                                            return (
                                                                <Grid
                                                                    item
                                                                    xs={4}
                                                                    key={`form-${field.name}`}
                                                                >
                                                                    <Typography
                                                                        variant={
                                                                            'body1'
                                                                        }
                                                                        color={
                                                                            '#fff'
                                                                        }
                                                                    >
                                                                        {
                                                                            field.label
                                                                        }
                                                                    </Typography>
                                                                    <TextField
                                                                        id="outlined-basic"
                                                                        fullWidth
                                                                        name={
                                                                            field.name
                                                                        }
                                                                        variant={
                                                                            isEditing
                                                                                ? 'outlined'
                                                                                : 'standard'
                                                                        }
                                                                        type={
                                                                            field.type
                                                                        }
                                                                        placeholder={
                                                                            field.placeholder
                                                                        }
                                                                        value={
                                                                            isEditing
                                                                                ? accountInfo[
                                                                                      field
                                                                                          .name
                                                                                  ] ||
                                                                                  ''
                                                                                : field.valueFormatter
                                                                                ? field.valueFormatter(
                                                                                      accountInfo[
                                                                                          field
                                                                                              .name
                                                                                      ] ||
                                                                                          '---'
                                                                                  )
                                                                                : accountInfo[
                                                                                      field
                                                                                          .name
                                                                                  ] ||
                                                                                  '---'
                                                                        }
                                                                        onChange={
                                                                            handleInputChange
                                                                        }
                                                                        size={
                                                                            'small'
                                                                        }
                                                                        disabled={
                                                                            !isEditing
                                                                        }
                                                                        inputProps={
                                                                            field.inputProps
                                                                        }
                                                                        InputProps={
                                                                            field.adornment
                                                                                ? {
                                                                                      startAdornment:
                                                                                          (
                                                                                              <InputAdornment position="start">
                                                                                                  {
                                                                                                      field.adornment
                                                                                                  }
                                                                                              </InputAdornment>
                                                                                          ),
                                                                                  }
                                                                                : {}
                                                                        }
                                                                        error={
                                                                            field.error
                                                                        }
                                                                        helperText={
                                                                            field.helperText
                                                                        }
                                                                        sx={{
                                                                            backgroundColor:
                                                                                '#fff',
                                                                            borderRadius: 2,
                                                                            '& .MuiInputBase-input.Mui-disabled':
                                                                                {
                                                                                    WebkitTextFillColor:
                                                                                        theme
                                                                                            .palette
                                                                                            .primary
                                                                                            .main,
                                                                                },
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            );
                                                        }
                                                    )}
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </SwipeableViews>
                    <MobileStepper
                        steps={5}
                        variant={'dots'}
                        activeStep={activeStep}
                        position={'bottom'}
                        sx={{
                            position: 'relative', // or 'absolute'
                            bottom: 15,
                            width: '100%', // full width
                            mt: 3,
                            mb: 3,
                        }}
                        nextButton={
                            <div
                                style={{
                                    width: activeStep === 4 ? '30%' : 'auto',
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                }}
                            >
                                {/* Fixed width container */}
                                {activeStep < 2 ? (
                                    <>
                                        <Button
                                            size="small"
                                            onClick={handleNext}
                                            variant="contained"
                                            color="primary"
                                            sx={{ mr: 2 }}
                                            disabled={
                                                activeStep === 0 &&
                                                (!accountInfo.firstName ||
                                                    !accountInfo.lastName ||
                                                    !accountInfo.phoneNumber)
                                            }
                                        >
                                            Continue
                                            {theme.direction === 'rtl' ? (
                                                <KeyboardArrowLeft />
                                            ) : (
                                                <KeyboardArrowRight />
                                            )}
                                        </Button>
                                    </>
                                ) : activeStep === 2 || activeStep === 3 ? (
                                    <Button
                                        size="small"
                                        onClick={handleNext}
                                        disabled={
                                            activeStep === 2
                                                ? !(
                                                      accountInfo.firstName &&
                                                      accountInfo.lastName &&
                                                      accountInfo.phoneNumber &&
                                                      !error
                                                  )
                                                : !policyCheck
                                        }
                                        variant={'contained'}
                                        color={'primary'}
                                        sx={{ mr: 2 }}
                                    >
                                        Continue
                                        {theme.direction === 'rtl' ? (
                                            <KeyboardArrowLeft />
                                        ) : (
                                            <KeyboardArrowRight />
                                        )}
                                    </Button>
                                ) : activeStep === 4 ? (
                                    <Button
                                        size="small"
                                        onClick={handleCreateClick}
                                        variant={'contained'}
                                        color={'primary'}
                                        sx={{ mr: 2 }}
                                    >
                                        Create My Workspace!
                                    </Button>
                                ) : null}
                            </div>
                        }
                        backButton={
                            <div
                                style={{
                                    width: activeStep === 4 ? '30%' : 'auto',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                }}
                            >
                                {' '}
                                {/* Fixed width container */}
                                <Button
                                    size="small"
                                    onClick={handleBack}
                                    disabled={activeStep === 0}
                                    color={'primary'}
                                    variant={'outlined'}
                                    sx={{ ml: 2 }}
                                >
                                    {theme.direction === 'rtl' ? (
                                        <KeyboardArrowRight />
                                    ) : (
                                        <KeyboardArrowLeft />
                                    )}
                                    Back
                                </Button>{' '}
                            </div>
                        }
                    />
                </Paper>
            </Grid>
        </Grid>
    );
};

export default Onboarding;
